<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="stock_transaction_type_list" id="my-table-id"
                class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Stock Transaction Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn rounded color="success" outlined
                                @click="fnExcelReport('my-table-id', 'Stock Transaction Types')"><v-icon
                                    color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mt-4 button" v-on="on" small>Add Stock Transaction Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined dense
                                                        hint="For e.g. Sale, Issue, Return, Purchase..."></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0">
                                                    <b>Display Name</b><v-icon class="pl-1 pb-2"
                                                        color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.display_name" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined
                                                        dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class=" v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                        </v-avatar>
                    </div>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        // extraBreadcrumbItems: [
        //     { text: "Stock Transaction Type", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style2",
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "Sr.No",
                align: "left",
                sortable: false,
                value: "sr_no",
            },
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Display Name",
                align: "left",
                sortable: false,
                value: "display_name",
            },
            {
                text: "Organization",
                align: "left",
                sortable: false,
                value: "organization",
            },
            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            name: "",
            isactive: true,
        },
        stock_transaction_type_list:[],
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Stock Transaction Type" : "Edit Stock Transaction Type";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Display Name</th>
            <th>Organization</th>
            <th>Status</th>
            </tr>`;

                this.stock_transaction_type_list.forEach((s) => {
                    let isactive = s.isactive ? 'Yes' : 'No';
                    tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.name}</td>
                <td>${s.display_name}</td>
                <td>${s.organization}</td>
                <td>${isactive}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        editItem(item) {
            this.editedIndex = this.stock_transaction_type_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/EduStore/editStockTransactionType", this.editedItem)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.onLoad();
                                Object.assign(this.stock_transaction_type_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Stock Transaction Type Updated Successfully...");
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.message); 
                            }  else {
                                this.showSnackbar("error", "Something went wrong...");
                            }                       
                        })
                        .catch((error) => {
                            this.showSnackbar("error", "Something went wrong...");
                            window.console.log(error);
                        });
                    this.close();
                }
            }
             else {
                axios
                    .post("/EduStore/saveStockTransactionType", this.editedItem)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.stock_transaction_type_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "Stock Transaction Type Added Successfully...");
                            this.onLoad();
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.message); 
                        } else {
                            this.showSnackbar("error", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Something went wrong...");
                        window.console.log(error);
                    });
                this.close();
            }
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/EduStore/getStockTransactionType")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        this.stock_transaction_type_list = res.data.stock_transaction_type_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },       

        deleteItem(item) {

            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const formData = {
                id: item.id,
            };

            axios
                .post("/EduStore/deleteStockTransactionType", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Stock Transaction Type Deleted Successfully...");
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); 
                    }
                });
        },
        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        },

        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/EduStore/toggleStockTransactionType", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.showSnackbar("success", "Stock Transaction Type Status Changed Successfully !"); 
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", "Something went wrong...");
                    } else{
                        this.showSnackbar("error", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("red", "Something went wrong");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
